module.exports = __webpack_public_path__ + "static/img/introduceBTypeBIcon12.7b69db2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introduceBTypeBIcon12.png
// module id = 4eYB
// module chunks = 0